import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { SharedModule } from "@bt/shared";
import { BrandModule } from "../brand/brand.module";

import { RestoreComponent } from './restore.component';
import { RestoreFormComponent } from "./form/component";
import { RestoreService } from "./restore.service";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        SharedModule,
        BrandModule
    ],
    declarations: [
        RestoreComponent,
        RestoreFormComponent
    ],
    providers: [
        RestoreService
    ]
})
export class RestoreModule { }


// WEBPACK FOOTER //
// ./src/app/public/restore/restore.module.ts